import { FC } from 'react';
import { PopoverAddMotiveLabelsProps } from '../PopoverAddMotive/PopoverAddMotive.types';
import { AllieText } from '../../../../../components';
import { formatDuration, getHourMinute } from '../../utils/helpers';
import { TimeRangeDisplayStyled } from './TimeRangeDisplay.styles';

interface TimeRangeDisplayProps {
  timeRange: [number, number];
  timezone?: string;
  reason?: string;
  labels: PopoverAddMotiveLabelsProps['labels'];
  breadcrumb?: string;
}

export const TimeRangeDisplay: FC<TimeRangeDisplayProps> = ({
  timeRange,
  timezone,
  reason,
  labels,
  breadcrumb,
}) => (
  <TimeRangeDisplayStyled>
    <AllieText type="body3" color="neutral-50">
    {`${getHourMinute(timeRange[0], timezone)} - 
        ${getHourMinute(timeRange[1], timezone)} 
        (${formatDuration(timeRange[1] - timeRange[0])})`}
    </AllieText>
    <AllieText type="body2" color="neutral-80" weight={600}>
      {reason || labels.withoutMotive}
    </AllieText>
    {breadcrumb && (
      <AllieText type="body3" color="neutral-50">
        {breadcrumb}
      </AllieText>
    )}
  </TimeRangeDisplayStyled>
);
